module.exports = __webpack_public_path__ + "img/email.2d7fef14.png";